import script from "./EditArticleRefinementModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditArticleRefinementModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__